import { useState, useEffect, useRef, } from "react";
import { useContext, useMemo } from "react";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import Transmitter from "../components/Transmitter";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import Valve from "../components/Valve";
import "./SlopTank.css";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import { PumpContext } from "../context/PumpContext"; 
import { ProcessContext } from "../context/ProcessContext";
import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";
import { PlantStore } from "../engine/PlantStore";
import { usePlantStore } from "../engine/usePlantStore";

import { trackPageVisit } from "../competency/PageTracker";
import TransmitterFaceplate from "../components/TransmitterFaceplate";





function ValveOutput({
    tag,
    value,
    x,
    y,
    r = 0,
    description = "Control Valve Opening"
}) {

    const [hover, setHover] = useState(false);
    const [showFaceplate, setShowFaceplate] = useState(false);

    return (
        <>
            {/* Hover */}
            {hover && (
                <div
                    style={{
                        position: "absolute",
                        left: x + 30,
                        top: y - 5,
                        background: "rgba(0,80,180,.85)",
                        color: "#fff",
                        padding: "5px 8px",
                        borderRadius: "4px",
                        border: "1px solid #4fc3ff",
                        fontSize: "11px",
                        zIndex: 9999,
                        pointerEvents: "none",
                        whiteSpace: "nowrap"
                    }}
                >
                    <strong>{tag}</strong><br />
                    {description}
                </div>
            )}

            {/* Original Valve Output */}
            <div
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={() => setShowFaceplate(true)}
                style={{
                    position: "absolute",
                    left: x,
                    top: y,

                    color: "lime",
                    background: "black",

                    fontSize: "10px",
                    padding: "1px 4px",

                    borderRadius: "4px",
                    border: "1px solid #555",

                    transform: `rotate(${r}deg)`,
                    transformOrigin: "center",

                    cursor: "pointer",

                    fontWeight: "bold",

                    minWidth: "22px",
                    textAlign: "center",

                    transition: "0.2s",
                    boxShadow: hover
                        ? "0 0 8px rgba(0,255,255,.7)"
                        : "none"
                }}
            >
                {Number(value).toFixed(1)} %
            </div>

            {showFaceplate && (
                <TransmitterFaceplate
                    tag={tag}
                    value={Number(value)}
                    unit="%"
                    min={0}
                    max={100}
                    HH={100}
                    H={90}
                    L={10}
                    LL={0}
                    description={description}
                    x={x + 35}
                    y={y + 20}
                    onClose={() => setShowFaceplate(false)}
                />
            )}
        </>
    );
}




function SlopTank() {

    useEffect(() => {
    
      trackPageVisit("SlopTank");
    
    }, []);
  
     const {  valves, toggleValve} = useContext(WellContext);

const [hoveredValve, setHoveredValve] = useState(null);
const {processData,  setProcessData} = useContext(ProcessContext);

     

  const DEFAULT_VALVES = {
  FCV_1601: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_1602: { mode: "Manual", opening: 0, sp: "", pv: "" },

};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("SlopTank_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_1601: { ...DEFAULT_VALVES.FCV_1601, ...parsed.FCV_1601 },
      FCV_1602: { ...DEFAULT_VALVES.FCV_1602, ...parsed.FCV_1602 },

    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("SlopTank_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };


  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};





const [panelPos, setPanelPos] = useState({ x: 0, y: 80 });
const [dragging, setDragging] = useState(false);
const offsetRef = useRef({ x: 0, y: 0 });

const handleMouseDown = (e) => {
  setDragging(true);

  offsetRef.current = {
    x: e.clientX - panelPos.x,
    y: e.clientY - panelPos.y,
  };
};

const handleMouseMove = (e) => {
  if (!dragging) return;

  setPanelPos({
    x: e.clientX - offsetRef.current.x,
    y: e.clientY - offsetRef.current.y,
  });
};

const handleMouseUp = () => {
  setDragging(false);
};

useEffect(() => {
  window.addEventListener("mousemove", handleMouseMove);
  window.addEventListener("mouseup", handleMouseUp);

  return () => {
    window.removeEventListener("mousemove", handleMouseMove);
    window.removeEventListener("mouseup", handleMouseUp);
  };
}, [dragging]);




const tagStyle = {
      position: "absolute",
      top: -30,
      left: "50%",
      transform: "translateX(-50%)",

      background: "black",
      color: "#00ffcc",

      fontSize: "13px",
      fontWeight: "bold",

      padding: "3px 8px",
      borderRadius: "4px",

      border: "1px solid #555",

      whiteSpace: "nowrap",
      zIndex: 999
    };




// ================= RETREIVING OF DATA FROM OTHER PAGES VIA LOCAL STROAGE =================

  
            const { transmitters, flowOverrides } = usePlantStore();
            const FIC_2607 = transmitters.FIC_2607 || 0;
            const FIC_18007 = transmitters.FIC_18007 || 0;
            const FIC_316011 = transmitters.FIC_316011 || 0;
            const FIC_116012 = transmitters.FIC_116012 || 0;
            const FIC_13012 = transmitters.FIC_13012 || 0;




  const xv1601Open = !valves?.XV_1601;
  const xv1602Open = !valves?.XV_1602;
  const xv1603Open = !valves?.XV_1603;
  const xv1604Open = !valves?.XV_1604;


  const FIC_1601 = FIC_2607 + FIC_18007 + FIC_316011;
  const FIC_1602 = FIC_116012 + FIC_13012;
  const FIC_16011 = xv1601Open ? FIC_1601 : 0;
  const FIC_16021 = xv1602Open ? FIC_1602 : 0;
  const FIC_1603 = FIC_16011 + FIC_16021;
  const FIC_1605 = FIC_1603 * 0.124;
  const FIC_1604 = 16.469 * (valveData?.FCV_1602?.opening || 0)/100;








  

   /* =========================================================
   PUMP CONTEXT
========================================================= */

const pumpContext = useContext(PumpContext) || {};
const pumpData = pumpContext.pumpData || {};


/* =========================================================
   P-1601A / P-1601B STATUS
========================================================= */

const P1601A_Running =
pumpData?.["P-1601A"]?.running ?? false;

const P1601B_Running =
pumpData?.["P-1601B"]?.running ?? false;

const P1601_Running =
P1601A_Running || P1601B_Running;


/* =========================================================
   PUMP CAPACITY
========================================================= */

const P1601_CAPACITY = 12.5;


/* =========================================================
   CONTROL VALVE
========================================================= */

const FCV1601_Opening =
(valveData?.FCV_1601?.opening || 0) / 100;


/* =========================================================
   TARGET FLOW
========================================================= */

const targetFIC1606 =
(
P1601_Running
)
?
P1601_CAPACITY *
FCV1601_Opening
:
0;


/* =========================================================
   FLOW UPDATE
========================================================= */

useEffect(()=>{

const timer=setInterval(()=>{

setProcessData(prev=>{

const current =
Number(prev.FIC_1606 || 0);

const next =
current +
(targetFIC1606-current)*0.12;

return{

...prev,

FIC_1606:
Number(next.toFixed(3))

};

});

},500);

return()=>clearInterval(timer);

},
[
targetFIC1606
]);



/* =========================================================
   PRESSURE + TEMPERATURE ENGINE
========================================================= */

useEffect(()=>{

const timer=setInterval(()=>{

setProcessData(prev=>{

const currentPressure =
Number(prev.PT_1601 || 0.03);

const currentTemp =
Number(prev.TT_1601 || 28);

const currentFlow =
Number(prev.FIC_1606 || 0);

let targetPressure = 0.03;
let targetTemp = 28;


/* =========================================
   PUMP RUNNING
========================================= */

if(P1601_Running){

/* -----------------------------------------
   PRESSURE
----------------------------------------- */

// Dead-head (Valve fully closed)

if(FCV1601_Opening<=0){

targetPressure=1.80;

}

// Highly restricted

else if(FCV1601_Opening<0.20){

const restriction =
(0.20-FCV1601_Opening)/0.20;

targetPressure=
0.80+
restriction*
1.00;

}

// Normal operation

else{

targetPressure=
0.80-
(
FCV1601_Opening-
0.20
)*0.18;

}


/* -----------------------------------------
   TEMPERATURE
----------------------------------------- */

targetTemp=28;

// Dead-head heating

if(FCV1601_Opening<=0){

targetTemp=36;

}

// Restricted flow heating

else if(FCV1601_Opening<0.20){

const restriction=
(0.20-FCV1601_Opening)/0.20;

targetTemp=
28+
restriction*4;

}

}


/* =========================================
   UPDATE
========================================= */

return{

...prev,

PT_1601:
Number(
(
currentPressure+
(
targetPressure-currentPressure
)*0.08
).toFixed(3)
),

TT_1601:
Number(
(
currentTemp+
(
targetTemp-currentTemp
)*0.08
).toFixed(2)
)

};

});

},500);

return()=>clearInterval(timer);

},
[
P1601_Running,
FCV1601_Opening
]);


/* =========================================================
   TRANSMITTERS
========================================================= */

const FIC_1606 = flowOverrides?.FIC_1606 ? 0 :
(Number(
processData.FIC_1606 || 0
));

const PT_1601 =
Number(
processData.PT_1601 || 0.03
);

const TT_1601 =
Number(
processData.TT_1601 || 28
);





  
useEffect(() => {

  const current =
    PlantStore.get().transmitters;


  if (
    current.FIC_1604 === FIC_1604 &&
    current.FIC_1606 === FIC_1606
  ) {
    return;
  }


  PlantStore.set({
    transmitters: {

      ...current,
      FIC_1604, FIC_1606
    }
  });

}, [FIC_1604, FIC_1606]);






  return (
    <div className="SlopTank-container">

      {/* TITLE */}
      <h2
        style={{
          position: "absolute",
          top: "0px",
          left: "260px",
          color: "white",
          background: "rgb(30, 5, 250)",
          padding: "2px 353px",
          zIndex: 10,
        }}
      >
        SLOP TANK
      </h2>


 {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-1601 */}
      <Valve
        className="XV-1601"
        tag="XV_1601"
        x={236}
        y={355}
        isClosed={valves.XV_1601}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-1602 */}
      <Valve
        className="XV-1602"
        tag="XV_1602"
        x={181}
        y={424}
        isClosed={valves.XV_1602}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-1603 */}
      <Valve
        className="XV-1603"
        tag="XV_1603"
        x={756}
        y={409}
        isClosed={valves.XV_1603}
        toggle={toggleValve}
        r={90}
      />
      




      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-1601 */}
        <div
            style={{ position: "absolute", left: 1080, top: 446}}
            onMouseEnter={() => setHoveredValve("FCV_1601")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_1601")}
          >

            {hoveredValve === "FCV_1601" && (
              <div style={tagStyle}>
                FCV_1601
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-1601">
                    
          <defs>
            <linearGradient id="metal_1601">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_1601)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_1601)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>
      

         {/* FCV-1602 */}
        <div
            style={{ position: "absolute", left: 438, top: 529, transform: "rotate(90deg)", transformOrigin: "center"}}
            onMouseEnter={() => setHoveredValve("FCV_1602")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_1602")}
          >

            {hoveredValve === "FCV_1602" && (
              <div style={tagStyle}>
                FCV_1602
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-1602">
                    
          <defs>
            <linearGradient id="metal_1602">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_1602)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_1602)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>
      
       
        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 160 + index * 40
              }}
            />
          ))}

           {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 160 + index * 40
              }}
            />
          ))}


 

      {/* ================= CONTROL VALVE OUTPUTS ================= */}


      <ValveOutput
        value={Number(valveData?.FCV_1601?.opening || 0)}
        x={1102}
        y={495}
      />

      <ValveOutput
        value={Number(valveData?.FCV_1602?.opening || 0)}
        x={425}
        y={548}
      />


      <Transmitter
        tag="FIC_1601"
        value={[FIC_1601]}
        x={145}
        y={240}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF UNQUALIFIED PRODUCTS FROM PRODUCT LINES"
      />

      <Transmitter
        tag="FIC_1602"
        value={[FIC_1602]}
        x={135}
        y={345}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF UNQUALIFIED CRUDE FROM DESALTER VESSESL V-1601 A/B"
      />

      <Transmitter
        tag="FIC_1603"
        value={[FIC_1603]}
        x={385}
        y={320}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF TOTAL UNQUALIFIED CRUDE INTO THE SLOP TANK"
      />

      <Transmitter
        tag="FIC_1604"
        value={[FIC_1604]}
        x={485}
        y={480}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF WATER AND SLUDGE DRAINED FROM SLOP TANK TO SUMP SYSSTEM FOR FURTHER TREATMENT"
      />

      <Transmitter
        tag="FIC_1606"
        value={[FIC_1606]}
        x={1155}
        y={440}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF CRUDE FROM SLOP TANK TO CRUDE TANK V-1304"
      />

      <Transmitter
        tag="PT_1601"
        value={[PT_1601]}
        x={985}
        y={490}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF CRUDE FROM SLOP TANK TO CRUDE TANK V-1304"
      />

      <Transmitter
        tag="TT_1601"
        value={[TT_1601]}
        x={985}
        y={380}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF CRUDE FROM SLOP TANK TO CRUDE TANK V-1304"
      />



    <LevelTransmitterIndicator
      tag="LT_1601"
      totalLevel={20000}
      inflows={[FIC_1603]}
      outflows={[FIC_1606]}
      inflowTags={["FIC_1603"]}
      outflowTags={["FIC_1606"]}
      responseFactor={0.05}
      columnX={679}
      columnY={199}
      columnWidth={30}
      columnHeight={212}
      textX={730}
      textY={240}
      showFlow={true}
      service="crude"
    />

    <LevelTransmitterIndicator
      tag="LT_1601"
      totalLevel={20000}
      inflows={[FIC_1603]}
      outflows={[FIC_1606]}
      inflowTags={["FIC_1603"]}
      outflowTags={["FIC_1606"]}
      responseFactor={0.05}
      columnX={494}
      columnY={199}
      columnWidth={219}
      columnHeight={212}
      textX={730}
      textY={240}
      showFlow={true}
      backgroundOpacity={0.01}
      liquidOpacity={0.1}
      service="crude"
    />

    <LevelTransmitterIndicator
      tag="LT_1602"
      totalLevel={20000}
      inflows={[FIC_1605]}
      outflows={[FIC_1604]}
      inflowTags={["FIC_1605"]}
      outflowTags={["FIC_1604"]}
      responseFactor={0.05}
      columnX={494}
      columnY={199}
      columnWidth={219}
      columnHeight={212}
      textX={400}
      textY={140}
      showFlow={true}
      backgroundOpacity={0.01}
      liquidOpacity={0.3}
      service="water"
    />


            <Pump
              tag="P-1601A"
              x={883}
              y={410}
              rpm={1800}
              bladeCount={pumpData?.["P-1601A"]?.bladeCount || 3}
              size={pumpData?.["P-1601A"]?.size || 45}
              onClick={openPumpPanel}
            />

            <Pump
              tag="P-1601B"
              x={882}
              y={516}
              rpm={1800}
              bladeCount={pumpData?.["P-1601B"]?.bladeCount || 3}
              size={pumpData?.["P-1601B"]?.size || 45}
              onClick={openPumpPanel}
            />





    </div>
  );
}

export default SlopTank;